import React, {useState} from 'react';
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {useDispatch} from "react-redux";
import {refresh} from "../../redux/slice/apiSlice";
import {
    TEXTAREA_AUTO_GROW_MAX_H,
    TEXTAREA_REMARK_MIN_H,
    useAutoResizeTextarea,
} from "./useAutoResizeTextarea";
import "./textareaAutoGrow.css";

function TextAreaUpdateBasic({target, required, listener, value, clicked, setClicked, style, callback}) {
    const [data, setData] = useState(value);
    const [updatedData, setUpdatedData] = useState();
    const dispatch = useDispatch();

    const {ref, syncHeight} = useAutoResizeTextarea(data, {
        minHeight: TEXTAREA_REMARK_MIN_H,
        maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
    });

    const textareaLayoutStyle = {
        width: '100%',
        padding: '4px 12px',
        textIndent: 0,
        lineHeight: 1.45,
        minHeight: TEXTAREA_REMARK_MIN_H,
        height: 'auto',
        maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
        boxSizing: 'border-box',
        ...style,
    };

    const inputStyle = {
        ...textareaLayoutStyle,
        backgroundColor: required && (!data || data.trim() === '') ? '#ffe5e5' : '',
        border: required && (!data || data.trim() === '') ? '2px solid #e53939' : '',
        outline: 'none',
    };

    const basicStyle = {
        ...textareaLayoutStyle,
    };

    const editHandler = async (event) => {
        if (event.keyCode === 13) {
            if (required && data.trim() === '') {
                alert("필수값입니다.")
                return;
            }

            const response = await listener({
                id: target.id,
                fieldName: target.fieldName,
                value: data,
                subId: target.subId
            });
            if (response.status === 200) {
                setUpdatedData(response.data)
                setClicked(false);
                handleActiveToast({message: "데이터가 수정되었습니다"});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
            dispatch(refresh(true))
        }
    }

    const handleKeyDownEvent = (e, data) => {
        if (e.key === 'Enter') {
            if (!e.shiftKey) {
                callback(data, target);
                setClicked(false);
            }
        }
    }

    return (
        <>
            {
                clicked ?
                    <textarea
                        ref={ref}
                        type={"text"}
                        className={`basic-input focus input-style textarea-auto-grow`}
                        value={data ? data : ''}
                        onChange={(event) => {
                            setData(event.target.value);
                            requestAnimationFrame(syncHeight);
                        }}
                        style={required ? inputStyle : basicStyle}
                        onKeyDown={callback ? (e) => handleKeyDownEvent(e, data) : editHandler}
                        autoFocus={true}
                        onBlur={() => {
                            setClicked(false);
                            setData(updatedData ? updatedData : value)
                        }}
                    /> :
                    <span className={"edit-input"}>
                        {data}
                    </span>
            }
        </>
    );
}

export default TextAreaUpdateBasic;
